import { useRef } from 'react'
import { useRemixFormContext } from 'remix-hook-form'
import { Error, useForm } from '#app/components/form/form'
import { Textarea } from '#app/components/ui/textarea.tsx'
import { Field, type FieldProps, InputContainer, Label } from './field.tsx'

export function TextareaField({
	name,
	label,
	layout: fieldLayout,
	className,
	readOnly,
	disabled,
	alwaysShowError = true,
	rows,
	autoFocus = false,
	hotKey,
}: {
	name: string
	label: string
	className?: string
	readOnly?: boolean
	disabled?: boolean
	rows?: number
	autoFocus?: boolean
	hotKey?: string
} & FieldProps & {
		length?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
	}) {
	const {
		register,
		formState: { errors },
		getFieldState,
	} = useRemixFormContext()

	const { layout: formLayout } = useForm()
	const { invalid, error } = getFieldState(name)
	const errorId = errors?.length ? `${name}-error` : undefined
	const layout = fieldLayout || formLayout
	const inputRef = useRef<HTMLTextAreaElement | null>(null)

	const { ref, ...rest } = register(name)

	return (
		<Field layout={layout} className={className}>
			<Label htmlFor={name} layout={layout}>
				{label}
			</Label>
			<InputContainer layout={layout}>
				<Textarea
					id={name}
					autoComplete="off"
					aria-invalid={invalid ? true : undefined}
					aria-describedby={errorId}
					readOnly={readOnly}
					disabled={disabled}
					autoFocus={autoFocus}
					{...rest}
					rows={rows}
					ref={(e) => {
						ref(e)
						inputRef.current = e
					}}
				/>
				{/* if text hints are necessary they can be added here */}
				{alwaysShowError || (error && <Error id={errorId} error={error} />)}
			</InputContainer>
		</Field>
	)
}
